import { Component, OnInit, OnDestroy } from "@angular/core";
import { CommonService } from "../../../services";
import { merge, Observable, Subject } from "rxjs";
import { DickerSelectListItem } from "../../../models/check-out.model";
import { Router, ActivatedRoute, UrlSegment } from "@angular/router";
import { switchMap, map, tap, takeUntil } from "rxjs/operators";
import { AuthService } from "../../../services/auth.service";
import { CheckOutService } from "../../../services/checkout.service";
import { ManageService } from "../../../services/manage.service";
import { CurrentUserModel,  } from "../../../models/account-ledger.model";
import { ApiResponse } from "../../../models/api-response.model";
import { PaymentDetails } from "../../../models/subscription-payment-detail.model";
import { combineLatest, of } from "rxjs";




@Component({
  selector: "app-subscription-edit-payment",
  templateUrl: "./subscription-edit-payment.component.html",
  styleUrls: ["./subscription-edit-payment.component.css"],
})
export class SubscriptionEditPayment implements OnInit, OnDestroy {

  tenantId: string;
  annuityId: string;
  programType: string;

  companyCode: string = "";
  title: string = "Edit Tenant Details";
  loadContent: boolean = false;
  paymentList: DickerSelectListItem[] = [];
  selectedPayment: string = "";
  ngUnsubscribe: Subject<void> = new Subject<void>();
  editable = false;
  public user$: Observable<CurrentUserModel>;

  selectedPaymentSubject: Subject<void> = new Subject<void>();

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private checkOutService: CheckOutService,
    private manageService: ManageService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.companyCode = this.commonService.readCookie("CompanyCode");

    $("#levelOne").animate(
      { scrollLeft: $("div.managesubscriptiondetails").width() + 505 },
      400
    );

    this.user$ = this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe));

    const payment$: Observable<PaymentDetails> = this.manageService.currentPaymentDetails;

    const customerPayments$: Observable<DickerSelectListItem[]> = this.user$.pipe(
      switchMap((user: CurrentUserModel) => {
        if (user.hasAdminAccess) {
          return this.checkOutService.GetSubscriptionDigitalWallet();
        } else if (user.hasPurchaseAccess) {
          return this.checkOutService.GetSubscriptionDigitalWallet(user.loginId);
        } else {
          return of([]);
        }
      })
    );

    const update$ = this.manageService.updateDigiwalWalletSubject.asObservable().pipe(switchMap(() => customerPayments$));

    const merge$ = merge(update$,customerPayments$);

    combineLatest([payment$, merge$]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      ([payment, customerPayments]) => {

        this.paymentList = customerPayments;

        if (payment.digitalWalletId) {

          const selectedPayment = customerPayments.find(m => m.value === payment.digitalWalletId);

          if (selectedPayment) {

            this.selectedPayment = selectedPayment.value;

            this.editable = true;

          }

        } else {

          this.editable = true;

        }

        this.loadContent = true;
      }
    )

    const route$ = this.activatedRoute.parent.parent.url.pipe(
      switchMap((url: UrlSegment[]) =>
        this.activatedRoute.parent.paramMap.pipe(
          map((param: any) => {
            return {
              programType: url.length === 2 ? url[1].path : url[0].path,
              tenantId: param.get("tenantId"),
              annuityId: param.get("annuityId")
            };
          })
        )
      )
    )

    const paymentUpdate$: Observable<ApiResponse> = route$.pipe(
      switchMap((params) => {
        if (params.annuityId && !params.tenantId) {
          return this.manageService.UpdateAnnuityDigitalWallet(this.selectedPayment, params.annuityId);
        } else {
          return this.checkOutService
            .UpdateEBillingCustomerNo(
              this.selectedPayment,
              params.tenantId,
              params.programType
            )
        }
      })
    );

    const result$ = this.selectedPaymentSubject.asObservable().pipe(takeUntil(this.ngUnsubscribe)).pipe(
      switchMap(() => {
        return paymentUpdate$;
      })
    )


    result$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: ApiResponse) => {
      if (value.status === true) {
        this.manageService.getOrRefreshSubscriptionOrderSubject.next(true);
        this.commonService.implementToast(value.responseMessage, "Success");
      } else {
        this.commonService.implementToast(value.responseMessage, "Error");
      }
    })

    // route$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
    //   this.tenantId = params.tenantId;
    //   this.programType = params.programType;
    //   this.annuityId = params.annuityId;
    // });

  }

  selectPaymentMethod() {

    this.selectedPaymentSubject.next();

    // if (this.annuityId && !this.tenantId) {
    //   this.manageService.UpdateAnnuityDigitalWallet(this.selectedPayment, this.annuityId)
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe((value: ApiResponse) => {
    //       if (value.status === true) {
    //         this.manageService.monitorBillingInfo("Annuity");
    //         this.commonService.implementToast(value.responseMessage, "Success");
    //       } else {
    //         this.commonService.implementToast(value.responseMessage, "Error");
    //       }
    //     })
    // } else {
    //   this.checkOutService
    //     .UpdateEBillingCustomerNo(
    //       this.selectedPayment,
    //       this.tenantId,
    //       this.programType
    //     )
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe((value: ApiResponse) => {
    //       if (value.status === true) {
    //         this.manageService.monitorBillingInfo("Subscription");
    //         this.commonService.implementToast(value.responseMessage, "Success");
    //       } else {
    //         this.commonService.implementToast(value.responseMessage, "Error");
    //       }
    //     })
    // }

  }

  resetPayment() {
    this.selectedPayment = "";
    this.selectedPaymentSubject.next();
    // this.selectPaymentMethod();
  }

  navigateToDigitalWallet() {
    this.router.navigate(["CreateDigitalWallet"], { relativeTo: this.activatedRoute });
    //this.router.navigateByUrl("/myAccount/digitalwallet?createNew=true");
  }

  close() {
    //$("#levelOne").animate({ scrollLeft: -$("#editenduser").width() }, 400);
    this.router.navigate(["../"], { relativeTo: this.activatedRoute });
    $("#levelOne").animate({ scrollLeft: 250 }, 400);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

